import {NativeModules, Platform} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import WizzeeLog from '../../lib/wizzeeLog';

export const EsimActivationStatus = {
  FAIL: 'ESIM_ACTIVATION_FAIL',
  SUCCESS: 'ESIM_ACTIVATION_SUCCESS',
  UNKNOWN: 'ESIM_ACTIVATION_UNKNOWN',
};

const eSimActivationStatusMap = {
  android: {
    0: EsimActivationStatus.SUCCESS, // success
    2: EsimActivationStatus.FAIL, // fail
    timeout: EsimActivationStatus.UNKNOWN,
  },
  ios: {
    0: EsimActivationStatus.UNKNOWN, // unknown
    1: EsimActivationStatus.FAIL, // fail
    2: EsimActivationStatus.SUCCESS, // success
    timeout: EsimActivationStatus.UNKNOWN,
  },
};
export const getESimActivationStatus = result => {
  let resultToUse = result;
  if (Platform.OS === 'android') {
    resultToUse = result.resultCode;
  }
  return (
    eSimActivationStatusMap[Platform.OS]?.[resultToUse] ||
    EsimActivationStatus.UNKNOWN
  );
};

export const isESimCompatibleAsyncStorageKey = 'IS_ESIM_COMPATIBLE';

export const getEsimCompatibility = () =>
  AsyncStorage.getItem(isESimCompatibleAsyncStorageKey)
    .then(value => value === 'true')
    .catch(e =>
      WizzeeLog.warn(`Error getting ${isESimCompatibleAsyncStorageKey}`, e),
    );

export const getTrpcESimManager = (): any | undefined => {
  const {WizzeeAndroidESimManager, WizzeeESimManager} = NativeModules;

  const platform = Platform.OS;
  switch (platform) {
    case 'ios':
      return WizzeeESimManager;
    case 'android':
      return WizzeeAndroidESimManager;
    default: 
      return undefined;
  }
};

export async function testNativeModule() {
  try {
    const result = await getTrpcESimManager()?.testModule();
    WizzeeLog.log('Test Module Result:', result);
  } catch (error) {
    WizzeeLog.error('Test Module Error:', error);
  }
}

export const setIsESimCompatibleToAsyncStorage = async () => {
  try {
    const platform = Platform.OS;
    let isESimCompatible = false;
    if (platform === 'ios') {
      isESimCompatible = await getTrpcESimManager()?.isESimCompatible(true);
    } else {
      isESimCompatible = await getTrpcESimManager()?.isESimCompatible();
    }

    if (isESimCompatible == undefined) {
      isESimCompatible = false;
    }

    if (typeof isESimCompatible === 'boolean') {
      AsyncStorage.setItem(
        isESimCompatibleAsyncStorageKey,
        isESimCompatible.toString(),
      );
      return isESimCompatible;
    }
  } catch (e) {
    WizzeeLog.warn('Error in setIsESimCompatibleToAsyncStorage', e);
  }
};
